import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { DealerUserEventSearchType, DealerPortalModule as Module } from '@jfw/types';
import { ModuleAccessService } from '../../services/module-access/module-access.service';

@Component({
  selector: 'app-referral-pods',
  templateUrl: './referral-pods.component.html',
  styleUrl: './referral-pods.component.scss',
  imports: [RouterLink],
})
export class ReferralPodsComponent {
  private readonly router = inject(Router);
  private readonly moduleAccessService = inject(ModuleAccessService);

  protected readonly newSite = toSignal(this.moduleAccessService.newSite$);

  protected readonly displayRegisterNewReferralEvent = toSignal(
    this.moduleAccessService.canAccessModule(Module.RegisterNewReferralEvent),
  );

  protected readonly displayReferralEventSearch = toSignal(
    this.moduleAccessService.canAccessModule(Module.ReferralEventSearch),
  );

  protected get searchType(): typeof DealerUserEventSearchType {
    return DealerUserEventSearchType;
  }

  protected searchEvents(searchType: DealerUserEventSearchType): void {
    this.router.navigate(['/event-search'], {
      queryParams: {
        searchType: searchType,
      },
    });
  }
}
